import { formatDecimal2 } from "./numberFormatters";
import type { BloodPressureData } from "./types";

interface HourlyBloodPressureData {
  datetime: string;
  hour: number;
  systolic: number;
  diastolic: number;
}

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

export const createTooltipLabel = (
  timeLabel: string,
  systolicValue: number,
  diastolicValue: number,
  index: number,
  filteredData: (BloodPressureData | HourlyBloodPressureData)[],
): string => {
  const data = filteredData[index];
  if (!data) return "";

  const systolic = "systolic" in data ? data.systolic : systolicValue;
  const diastolic = "diastolic" in data ? data.diastolic : diastolicValue;

  return `${timeLabel}\nSystolic: ${formatDecimal2(systolic)} mmHg\nDiastolic: ${formatDecimal2(diastolic)} mmHg`;
};

export const generateTooltipTimeLabel = (
  selectedRange: TimeRange,
  index: number,
  filteredData: (BloodPressureData | HourlyBloodPressureData)[],
): string => {
  const data = filteredData[index];
  if (!data) return "";

  if (selectedRange === "1d") {
    const hourlyData = data as HourlyBloodPressureData;
    const hour = hourlyData.hour ?? 0;
    return `${hour}:00`;
  } else {
    const dailyData = data as BloodPressureData;
    const date = new Date(dailyData.date);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }
};

export const formatDate = (
  dateString: string,
  timeRange: TimeRange,
): string => {
  const date = new Date(dateString);

  switch (timeRange) {
    case "1d":
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    case "7d":
      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    case "1m":
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    case "6m":
    case "1y":
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    default:
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
  }
};
